module.exports = __webpack_public_path__ + "static/media/download_gif_stable.24be6a81.png";